import React, {useEffect, useState} from "react"
import utils from "../../utils/utils";
import axiosInstance from "../../api/axios";
import {showErrorNotify, showSuccessNotify} from "../../components";
import {BooleanInput, CheckboxGroupInput, showNotification, SimpleForm} from "react-admin";
import SimpleToolbar from "../../components/SimpleToolbar";
import TreeCheckBoxCustomInput from "../../components/TreeCheckBoxCustomInput";
import {connect} from 'react-redux';
import {compose} from 'redux';
import withStyles from '@material-ui/core/styles/withStyles';
import {CircularProgress} from "@material-ui/core";

const FaceCreate = () => {
    const [customers, setCustomers] = useState([])
    const [originalCustomers, setOriginalCustomers] = useState([])
    const [selected, setSelected] = useState([])
    const [registeredCustomerMap, setRegisteredCustomerMap] = useState({})
    const [devices, setDevices] = useState([])
    const [selectedDeviceNos, setSelectedDeviceNos] = useState([])
    const [showUnregistered, setShowUnregistered] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);

            try {
                const [
                    enrollmentRes,
                    faceRes,
                    deviceRes
                ] = await Promise.all([
                    axiosInstance.get('/api/enrollmentForFaceId'),
                    axiosInstance.get('/api/face?size=9999'),
                    axiosInstance.get('/api/accessDevices/search/findByType?type=FACE'),
                ]);

                // ===== enrollmentForFaceId =====
                if (enrollmentRes.status === 200) {
                    const content = enrollmentRes.data.content || [];
                    setOriginalCustomers(content);
                    setCustomers(content);
                }

                // ===== face =====
                if (faceRes.status === 200) {
                    const map = faceRes.data.content.reduce((obj, item) => {
                        const customerId = Number(item.id.split('-')[0]);
                        obj[customerId] = item;
                        return obj;
                    }, {});

                    setRegisteredCustomerMap(map);
                }

                // ===== accessDevices =====
                if (
                    deviceRes.status === 200 &&
                    deviceRes.data.length > 0
                ) {
                    setDevices(deviceRes.data);
                }
            } catch (error) {
                console.error('Load FaceId data failed', error);
            } finally {
                setIsLoading(false);
            }
        };
        loadData();
    }, []);


    const save = () => {
        const customerIds = utils.extractCustomerIdsV2(selected)
        axiosInstance.post('/api/face', {customerIds, deviceNos: selectedDeviceNos}).then(res => {
            showSuccessNotify('Đăng ký thành công')
        }, err => {
            showErrorNotify(err.message)
        });
    }

    const filterCustomers = (deviceNos = []) => {
        const isRegisterOnDevices = (customerId) =>
            !!deviceNos.length
            && deviceNos.every(deviceNo => registeredCustomerMap[customerId]?.machineBoxId?.split(",").includes(deviceNo.toString()))

        return originalCustomers.filter(item => !item.customerId || !isRegisterOnDevices(item.customerId))
    }

    const onChangeSelectedDevices = (deviceNos = []) => {
        setSelectedDeviceNos(deviceNos)

        if (showUnregistered)
            setCustomers(filterCustomers(deviceNos))
    }

    return (
        isLoading ? <CircularProgress style={{marginLeft: 10}} color="secondary"/>
            :
            <SimpleForm toolbar={<SimpleToolbar/>} save={save}>
                <BooleanInput label='Chưa đăng ký' options={{value: showUnregistered}} onChange={(event) => {
                    const checked = event.currentTarget.checked;
                    setShowUnregistered(checked)
                    if (checked) {
                        setCustomers(filterCustomers(selectedDeviceNos))
                    } else {
                        setCustomers([...originalCustomers])
                    }
                }}/>

                {devices?.length > 0 && <CheckboxGroupInput label='Thiết bị' source="deviceNos"
                                                            choices={devices.map(item => ({
                                                                id: item.deviceNo,
                                                                name: item.name
                                                            }))}
                                                            onChange={(_, values) => onChangeSelectedDevices(values)}
                />}

                <label><b>Danh sách người tham dự</b></label>
                <div style={{width: 500, maxHeight: '300px', overflow: 'auto', marginTop: 10}}>
                    <TreeCheckBoxCustomInput data={customers} expandTopLevel={true} onChange={setSelected}/>
                </div>
            </SimpleForm>
    )
}

export default compose(
    connect(null, {showNotification}),
    withStyles(null)
)(FaceCreate)
